export const breasts = {
  left: 'LEFT',
  right: 'RIGHT',
  both: 'BOTH'
} as const;

export type breastType = typeof breasts[keyof typeof breasts];
